import { Gender, PhoneNumberType } from '@massilia/prisma-generated/enums';
import { z } from 'zod';
import { emptyStringToNull } from '../_shared/coerce.js';
import { isoDateString } from '../_shared/dates.js';
import { personName } from '../_shared/person-name.js';
export const importBookingSchema = z.object({
    email: z
        .string()
        .min(1, "L'adresse email est requise.")
        .email('Veuillez saisir une adresse email valide.'),
    lastName: z.string().min(1, 'Le nom de famille est requis.'),
    dossierNumber: z.string().min(1, 'Le numéro de dossier est requis.'),
});
export const updateEmailsSchema = z.object({
    email: z.string().email(),
    secondaryEmail: emptyStringToNull(z.string().email()),
    password: z.string().min(1),
});
export const updatePasswordSchema = z.object({
    confirmNewPassword: z.string().min(8),
    currentPassword: z.string().min(1),
    newPassword: z.string().min(8),
});
export const phoneNumberItemSchema = z.object({
    id: z.string().optional(),
    number: z.string().min(1),
    type: z.nativeEnum(PhoneNumberType),
});
export const updatePhoneNumbersSchema = z.object({
    phoneNumbers: z.array(phoneNumberItemSchema),
});
export const updateProfileSchema = z.object({
    firstName: personName(),
    lastName: personName(),
    birthDate: emptyStringToNull(isoDateString()),
    gender: emptyStringToNull(z.nativeEnum(Gender)),
});
